var map = {
	"./Abhinav/images/Customerlimit.svg": [
		90670,
		670
	],
	"./Agrasen/images/Customerlimit.svg": [
		22458,
		2458
	],
	"./Bhagini/images/Customerlimit.svg": [
		37519,
		7519
	],
	"./DMKJ/images/Customerlimit.svg": [
		6281,
		6281
	],
	"./Deogiri/images/Customerlimit.svg": [
		56822,
		6822
	],
	"./JCOM/images/Customerlimit.svg": [
		70332,
		332
	],
	"./MOGAVEERA/images/Customerlimit.svg": [
		20246,
		246
	],
	"./Mahesh/images/Customerlimit.svg": [
		31049,
		1049
	],
	"./NCBM/images/Customerlimit.svg": [
		47529,
		7529
	],
	"./Noble/images/Customerlimit.svg": [
		78711,
		8711
	],
	"./RSSB/images/Customerlimit.svg": [
		62997,
		2997
	],
	"./Samta/images/Customerlimit.svg": [
		10291,
		291
	],
	"./Satara/images/Customerlimit.svg": [
		4917,
		4917
	],
	"./Sawji/images/Customerlimit.svg": [
		45063,
		7444
	],
	"./Shriraksh/images/Customerlimit.svg": [
		73656,
		3656
	],
	"./Suvarna/images/Customerlimit.svg": [
		92743,
		2743
	],
	"./Ucob/images/Customerlimit.svg": [
		34094,
		4094
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 22173;
module.exports = webpackAsyncContext;